/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_3Inputs */

const en_cp_give_3 = /** @type {(inputs: Cp_Give_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client viewer for lecturers & problem owners, unlimited`)
};

const id_cp_give_3 = /** @type {(inputs: Cp_Give_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client viewer untuk dosen & pemilik masalah, tanpa batas jumlah`)
};

/**
* | output |
* | --- |
* | "Client viewer for lecturers & problem owners, unlimited" |
*
* @param {Cp_Give_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_3 = /** @type {((inputs?: Cp_Give_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_3(inputs)
	return en_cp_give_3(inputs)
});